import { Anchor, Icon } from 'components/atoms';
import { useRouter } from 'next/router';
import React from 'react';
import type { AdditionalPlusInfoPage } from 'types';
import { copyQuery, getNatPersonNameAndBirthdate } from 'utils';
import { useTranslation } from 'utils/hooks';

import css from './FunktionsTimeline.module.scss';

interface AdditionalPlusInfoPageProps
{
  dto: AdditionalPlusInfoPage<any>;
  children: React.ReactNode;
  beta?: boolean;
}

const FunktionsTimeline: React.FC<AdditionalPlusInfoPageProps> = ({ children, dto, beta = false }) =>
{
  const { t } = useTranslation();
  const router = useRouter();
  const tier = dto.tier;

  const displayName = (() =>
  {
    if (dto.name !== undefined) return `${dto.name} (${t('formats:fbNr', { value: dto.id })})`;
    return tier === 'Plus' ? getNatPersonNameAndBirthdate(t, dto.hauptPersonenDaten.fullName, dto.hauptPersonenDaten.geburtsdatum) : dto.hauptPersonenDaten.fullName;
  })();

  const profileUrl = {
    pathname: router.pathname.substring(0, router.pathname.lastIndexOf('/')),
    query: copyQuery(router.query, ['id', 'token']),
  };

  return (
    <div className={css.container}>
      <div className={css.header}>
        <div>
            <h1>
              {displayName}
              {beta && <span className={css.beta}>{t('profiles:beta')}</span>}
            </h1>
          {dto.datum !== undefined && (<span>{t('profiles:aktuellSeit', { datum: dto.datum })}</span>)}
        </div>
        <Anchor as="button" asVariant="secondary" href={profileUrl}>
          <Icon name="minimize" />
          &nbsp;
          {t('profiles:actions.closeFullscreen')}
        </Anchor>
      </div>
      {children}
    </div>
  );
};

export default FunktionsTimeline;
